import React, { useEffect } from 'react'

import ComponentContainer from './utils/ComponentContainer';

const Map = () => {

    useEffect(() => {
        (function () {
            var setting = {"height":531,"width":803,"zoom":12,"queryString":"Paris, France","place_id":"ChIJD7fiBh9u5kcRYJSMaMOCCwQ","satellite":false,"centerCoord":[48.85887768818028,2.347059934212381],"cid":"0x40b82c3688c9460","lang":"fr","cityUrl":"/france/paris","cityAnchorText":"Carte de Paris, Ile de France, France","id":"map-9cd199b9cc5410cd3b1ad21cab2e54d3","embed_id":"329715"};
            var d = document;
            var s = d.createElement('script');
            s.src = 'https://1map.com/js/script-for-user.js?embed_id=329715';
            s.async = true;
            s.onload = function (e) {
            window.OneMap.initMap(setting)
            };
            var to = d.getElementsByTagName('script')[0];
            to.parentNode.insertBefore(s, to);
            })();
        return () => {
            (function () {
                var d = document;
                var to = d.getElementsByTagName('script')[0];
                if(to.src === "https://1map.com/js/script-for-user.js?embed_id=329715") {
                    to.parentNode.removeChild(to);
                    window.OneMap = null;
                }
            })();
        }
    }, [])

    return (
        <ComponentContainer>
            <div className="map">
                <p>Find us !</p>
                <div id="wrapper-9cd199b9cc5410cd3b1ad21cab2e54d3">
                    <div id="map-9cd199b9cc5410cd3b1ad21cab2e54d3"></div>
                </div>
            </div>
        </ComponentContainer>
    )
}

export default Map
